/**
 * Created by hl on 2019/1/7.
 */
import BizXfThemepack from './biz-xf-themepack.vue';

export default BizXfThemepack;
